import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import MainLayout from "../../components/layout/MainLayout";
import AuthGuard from "../../components/route-guard/AuthGuard";
import { useRouter } from "../../helper-functions/useRouterReplacement";
import Chatting from "../../components/chat/Chatting";
import SEO from "../../components/seo";
import useConfigData from "../../hooks/useConfigData";
import SplashScreen from "../../splash-screen";

const Index = () => {
    const { configData, landingPageData, loading } = useConfigData();
    const router = useRouter();

    return (
    <>
      {loading ? (
        <SplashScreen />
      ) : (
        <>
          <CssBaseline />
          <SEO
            title={configData ? `Chat` : "Loading..."}
            image={`${configData?.base_urls?.business_logo_url}/${configData?.fav_icon}`}
            businessName={configData?.business_name}
          />
          <MainLayout configData={configData} landingPageData={landingPageData}>
            <AuthGuard from={router.pathname.replace("/", "")}>
              <Chatting configData={configData} />
            </AuthGuard>
          </MainLayout>
        </>
      )}
    </>
  );
};

export default Index;
